module.exports = new __parcel__URL__("javascript.d7864fff.svg").toString();